import {ajax_get, ajax_post} from "./common_api";

//教育资讯、奕杰动态列表查询
export const newsList = (data) => ajax_post("/information/selectInformationPage", data)

//教育资讯、奕杰动态详情查询
export const newsDetail = (data) => ajax_post("/information/selectInformationDetail", data)

// 首页统计
export const homeCount = (data) => ajax_get("/user/countYjWebSiteUserNum",data)